import React, { FC } from 'react';
import { Button as ButtonConstructor, ButtonProps as ButtonConstructorProps } from '@lst/mk-fe-design-system';
import { playButtonClickSound } from '@lst/web2clientapi/sound';

export interface ButtonProps extends ButtonConstructorProps {
  onClick: () => void;
}

export const Button: FC<ButtonProps> = ({onClick, ...props}) => {

  const onButtonClick = () => {
      playButtonClickSound();
      onClick();
  };

  return (
        <ButtonConstructor size='s' uppercase onClick={onButtonClick} {...props} />
  );
};
